const rebrandedAppUrl = `https://${process.env.APP_DOMAIN_REBRAND}${window.location.pathname}${window.location.search}`;

const isOldDomain = window.location.hostname === process.env.APP_DOMAIN;

export const shouldRedirectToRebrandedDomain = isOldDomain && process.env.REBRAND_ENABLED === 'true';

export const redirectToRebrandedUrl = () => {
  window.location.replace(rebrandedAppUrl);
};



// WEBPACK FOOTER //
// ./src/config/rebrand/helpers/index.js